import { useState } from 'react';

import { BsArrowLeft, BsChatSquareDotsFill } from 'react-icons/bs'
import { FaChevronDown } from 'react-icons/fa'
import { RxLapTimer } from 'react-icons/rx';
import { MdOutlineTimer } from 'react-icons/md';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { RiChatDeleteFill, RiChatDownloadFill } from 'react-icons/ri';
const MultipleDifficolta = (props) => {

    const { setInstruction, setMultipleDifficolta, setGiocatori, setMultipleCoppiaEsay, setMultipleCoppiaeNormal, setMultipleCoppiaHard, setShowSliderInfinite } = props;
    // const [clickedItem, setClickedItem] = useState(null);

    const handlePlanctonClick = () => {
        setMultipleDifficolta(true);
        setShowSliderInfinite(true);
        setMultipleCoppiaEsay(true);
        localStorage.setItem('clickedItem', 'CoppiaPlancton'); // Save the clicked item to local storage
    };

    const handleGamberoniClick = () => {
        setMultipleDifficolta(true);
        setShowSliderInfinite(true);
        setMultipleCoppiaeNormal(true);
        localStorage.setItem('clickedItem', 'CoppiaGamberone'); // Save the clicked item to local storage
    };

    const handleAsticiClick = () => {
        setMultipleDifficolta(true);
        setShowSliderInfinite(true);
        setMultipleCoppiaHard(true);
        localStorage.setItem('clickedItem', 'CoppiaAstice'); // Save the clicked item to local storage
    };

    const handleback = () => {
        setGiocatori(false);
    };
    const gioca = () => {
        setInstruction(true)
    }
    return (
        <div className='difficolta_container'>
            <div className='difficolta_header'>
                <BsArrowLeft className='header_icon' onClick={handleback} />
                <AiOutlineInfoCircle className='header_icon' onClick={gioca} />
            </div>
            <div className='main_div'>
                <div className='difficolta_heading_div'>
                    <h1 className='difficolta_heading'>Seleziona</h1>
                    <h1 className='difficolta_heading'>una difficolta</h1>
                </div>
                <div className="cards_main">
                    <div className='difficolta_card card_one' onClick={handlePlanctonClick}>
                        <div className='difficolta_card_text_div'>
                            <h1>Plancton</h1>
                            <div className='icon_and_text'>
                                <RxLapTimer className='timer_icon' />
                                <h3>Stop al timer</h3>
                            </div>
                            <div className='down_icon_div'>
                                <FaChevronDown className='down_arrow_icon' />
                            </div>
                            <div className='icon_and_text'>
                                <BsChatSquareDotsFill className='timer_icon' />
                                <h3>Respira e controlla la risporta</h3>
                            </div>
                        </div>
                    </div>
                    <div className='difficolta_card card_two' >
                        <div className='difficolta_card_text_div' onClick={handleGamberoniClick}>
                            <h1>Gamberone</h1>
                            <div className='icon_and_text'>
                                <MdOutlineTimer className='timer_icon' />
                                <h3>Il timer continua</h3>
                            </div>
                            <div className='down_icon_div'>
                                <FaChevronDown className='down_arrow_icon' />
                            </div>
                            <div className='icon_and_text'>
                                <RiChatDownloadFill className='timer_icon' />
                                <h3>Moviti, controlla la risposta!</h3>
                            </div>
                        </div>
                    </div>
                    <div className='difficolta_card card_three'>
                        <div className='difficolta_card_text_div' onClick={handleAsticiClick}>
                            <h1>Astice</h1>
                            <div className='icon_and_text'>
                                <MdOutlineTimer className='timer_icon' />
                                <h3>Il timer continua</h3>
                            </div>
                            <div className='down_icon_div'>
                                <FaChevronDown className='down_arrow_icon' />
                            </div>
                            <div className='icon_and_text'>
                                <RiChatDeleteFill className='timer_icon' />
                                <h3>Nessun controllo disponibile</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MultipleDifficolta